<ngx-smart-modal [customClass]="'msg-modal'" identifier="{{dynamicID}}" [closable]="false" [dismissable]="false" [escapable]="false">
  <div class="modal-header">
    <span [ngClass]="type | modalCssHelper">{{contentHeader || "Are You Sure?"}}</span>
  </div>
  <div style="padding-left: 16px;padding-bottom: 16px;padding-right: 16px">
    <div class="header-helper" [innerHTML]="content"></div>

    <div class="grid-x save-cancel-button-group" *ngIf="!commentMode">
      <button class="iana-button-cancel" *ngIf="closeButtonText" (click)="closeModal()">{{closeButtonText}}</button>
      <button *ngIf="hasAcceptButton" class="iana-button" (click)="proceedClicked()">{{acceptButtonText || "close"}}</button>
    </div>
    <form [formGroup]="commentForm" (ngSubmit)="recordComment()" novalidate *ngIf="commentMode">
      <textarea *ngIf="!textFieldMode" formControlName="comment" rows="5" placeholder="{{placeholder}}"></textarea>
      <input class="float-center" *ngIf="textFieldMode" formControlName="commentInput" placeholder="{{placeholder}}" />
      <lib-whitelist-character-error [whitelistFormControl]="comment"></lib-whitelist-character-error>
      <div class="save-cancel-button-group">
        <button class="iana-button-cancel" type="reset" (click)="closeModal()">{{closeButtonText || 'Cancel'}}</button>
        <button *ngIf="hasAcceptButton" class="iana-button" type="submit" [disabled]="required && !commentForm.valid">{{acceptButtonText || "Submit"}}
        </button>
      </div>
    </form>
  </div>
</ngx-smart-modal>
